import { useTranslations } from "next-intl";
import { groupByFirstLetter, sortAlphabetically } from "@utils/alphabeticalSorting";
import BrandTagButtons from "./BrandTagButtons";
import BrandLetterGroup from "./BrandLetterGroup";
import AlphabetSummary from "./AlphabetSummary";

function BrandGlossary({ brands, tag, setTag }) {
  const t = useTranslations("brands");

  if (!brands || brands.length === 0) return null;

  const sortedBrands = sortAlphabetically([...brands]);
  const brandsByLetter = groupByFirstLetter(sortedBrands);

  const letters = Object.keys(brandsByLetter).sort((a, b) => {
    if (a === "+" && b !== "+") return 1;
    if (a !== "+" && b === "+") return -1;
    return a.localeCompare(b);
  });

  if (letters.length === 0) return null;

  return (
    <div className="pt-5 d-flex flex-column">
      <h4 className="mb-3 brands-wrapper-padding-x">{t("brand_glossary.title")}</h4>
      <p className="mb-4 brands-wrapper-padding-x">{t("brand_glossary.description")}</p>

      <BrandTagButtons
        tag={tag}
        setTag={setTag}
      />

      <section className="brand-glossary brands-wrapper-padding-x">
        <BrandLetterGroup
          letters={letters}
          brandsByLetter={brandsByLetter}
        />
        <AlphabetSummary brandsByLetter={brandsByLetter} />
      </section>
    </div>
  );
}

export default BrandGlossary;
